import { render } from "./DocsCallout.vue?vue&type=template&id=83a05576"
import script from "./DocsCallout.vue?vue&type=script&lang=js"
export * from "./DocsCallout.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mirox/Desktop/coreui-free-vue-admin-template-main/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__